import React from 'react';
import { FadeIn } from './FadeIn';
import { PriceCTA } from './PriceCTA';
import { Lock, CreditCard, Users, Star } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 md:py-32 px-6 bg-charcoal text-cream border-t border-white/10 relative overflow-hidden" data-id="element-72">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-[300px] bg-terracotta/10 blur-[100px] rounded-full pointer-events-none" data-id="element-73" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-74">
        <FadeIn data-id="element-75">
          <h2 className="text-4xl md:text-6xl font-serif mb-8 leading-tight" data-id="element-76">
            Tu mente resuelta{' '}
            <span className="italic text-terracotta" data-id="element-77">este fin de semana</span>
          </h2>
          <p className="text-xl text-cream/70 font-light mb-12 max-w-2xl mx-auto" data-id="element-78">
            Dejá de depender de la motivación o de tips sueltos. Implementá un
            sistema que te devuelva el control hoy mismo.
          </p>

          <div className="mb-10" data-id="element-79">
            <PriceCTA data-id="element-80" />
          </div>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-cream/60 mb-12" data-id="element-81">
            <div className="flex items-center gap-2" data-id="element-82">
              <Lock size={16} className="text-terracotta" data-id="element-83" />
              <span data-id="element-84">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-85">
              <CreditCard size={16} className="text-terracotta" data-id="element-86" />
              <span data-id="element-87">Mercado Pago disponible</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-88">
              <Users size={16} className="text-terracotta" data-id="element-89" />
              <span data-id="element-90">Más de 500 personas ya recuperaron el control</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-91">
              <Star size={16} className="text-terracotta fill-terracotta" data-id="element-92" />
              <span data-id="element-93">4.9/5 de Calificación</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}